import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import MOCK_DATA from './paymentController.json';

const queryPaymentInfo = (req, res, ctx) => {
  const responseData = MOCK_DATA['paymentController/queryPaymentInfo'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};


const getFastLoginInfo = (req, res, ctx) => {
  const responseData = MOCK_DATA['paymentController/getFastLoginInfo'].success.default;
    return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const execBankPay = (req, res, ctx) => {
  const responseData = MOCK_DATA['paymentController/execBankPay'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const getPostpaidCreditCard3DUrl = (req, res, ctx) => {
  const responseData = MOCK_DATA['paymentController/getPostpaidCreditCard3DUrl'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(getApiEndpoint('paymentController/queryPaymentInfo'), withScenario(withAuthCheck(queryPaymentInfo))),
  rest.post(getApiEndpoint('paymentController/getFastLoginInfo'), withScenario(getFastLoginInfo)),
  rest.post(getApiEndpoint('paymentController/execBankPay'), withScenario(withAuthCheck(execBankPay))),
  rest.post(
    getApiEndpoint('paymentController/getPostpaidCreditCard3DUrl'),
    withScenario(withAuthCheck(getPostpaidCreditCard3DUrl))
  ),
];
